export function ExchangeLogo({ height = 25 }: { height?: number }) {
  return (
    <img
      src="https://res.cloudinary.com/dyuuf6gor/image/upload/v1693255293/gifts/1031-logo_ote4if.png"
      alt="Exchange Logo"
      height={height}
      style={{ display: "block" }}
    />
  );
}
